/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import ResetPassword from './layout';

import {
  authenticatedAndBrandingReady,
  platformViewOnlyMode,
  getUserName,
} from '../../redux/modules/userData/selectors';
import { isInIframe } from 'serenova-js-utils/browser';

import { changeLocale } from '../../redux/modules/language';
import { selectCurrentLocale } from '../../redux/modules/language/selectors';

export function mapStateToProps(state) {
  return {
    hasStarted: authenticatedAndBrandingReady(state),
    platformViewOnlyMode: platformViewOnlyMode(state),
    insideIframe: !isInIframe(),
    locale: selectCurrentLocale(state),
    getUserName: getUserName(state),
  };
}

export const actions = {
  changeLocale,
};

export default connect(mapStateToProps, actions)(ResetPassword);
